import CSEServiceV1 from './CSEServiceV1'
import APIService from '@/api/services/APIService/APIServiceImpl'

import axios from 'axios'
import { CSEService } from '@/service'
import { SingleCompanyConfiguration } from '@/types/singleCompanyConfiguration'

export default class CSEServiceV1Impl
    extends APIService
    implements CSEServiceV1 {
    cseService: CSEService
    constructor() {
        const serviceUrl = window.env.VUE_APP_SINGLE_COMPANY_CONFIGURATION_URL
        if(!serviceUrl) throw new Error("serviceUrl is mandatory in CSEServiceV1Impl")
        super(serviceUrl)
        
        this.cseService = new CSEService(window.locale)
        this.cseService.init()
    }

    async getBookingFunnelSingleCompanyConfig(): Promise<SingleCompanyConfiguration> {
        try{
            console.log("getBookingFunnelSingleCompanyConfig ~ getBookingFunnelSingleCompanyConfig: this.cseService", this.cseService)
            const company: string | undefined = this.cseService.company
            if(!company) throw new Error("Company cant be undefined")

            const { data } = await axios.get<SingleCompanyConfiguration>(this.getServiceUrl(),{params:{companyName: company}})
            console.log("getBookingFunnelSingleCompanyConfig ~ data:", data)
            return data
        }catch(err) {
            throw new Error(`[getBookingFunnelSingleCompanyConfig] - Error: ${err}`)
        }
    }
}
